import React from 'react';
import PropTypes from 'prop-types';
import ButtonBase from 'components/controls/ButtonBase';
import BaseModal from 'components/dialogs/BaseModal';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Grid, Hidden } from '@material-ui/core';
import { ReactComponent as ErrorImage } from 'assets/images/errorImage.svg';
import { abreviaturas, masterMessages, masterEvents } from 'constantes';
import { AnalyticsAmplitud } from 'utils/Analytics-Amplitud';
import authService from 'auth/AuthService';

// Estilos de la pagina
const useStyles = makeStyles(() => ({
    imgContainerModalDownload: {
        textAlign: 'center',
        width: '50%',
        height: '40%',
    },
    imgModalProceso: {
        width: '90%',
        height: 'auto',
        marginBottom: 2,
    },
}));

function BaseModalError({
  handleCloseModal, maxWidth, messages, buttonTitle, close,
  }) {
    const classes = useStyles();
    const history = useHistory();
    // Mensajes mostrar
    const { buttons } = masterMessages;

    /**
     * @name onClickModalExit
     * @desc Lleva nuevamente a pagina de logueo tras mostrar error
     */
    const onClickModalExit = async () => {
        authService.logout();
        // Conexión con analiticas al salir del aplicativo
        AnalyticsAmplitud.registerEvent(masterEvents.EVENTO_TERMINAT_SESION);
        history.push('/apiv1/sign-in');
    };

    return (
      <BaseModal
        open
        onClose={handleCloseModal}
        title={messages.title}
        maxWidth={maxWidth}
        close={close}
      >
        <Grid container>
          <Hidden only={['xs', 'md']}>
            <Grid item sm={12} md={12} xl={12}>
              <Container className={classes.imgContainerModalDownload}>
                <ErrorImage className={classes.imgModalProceso} />
              </Container>
            </Grid>
          </Hidden>
          <Grid item xs={12} md={12}>
            <p>{messages.message}</p>
          </Grid>
          <Grid container alignItems="center" justifyContent="center">
            <Grid item xs={6} md={6}>
              <ButtonBase
                caption={buttonTitle || buttons.exit}
                colorBase={abreviaturas.DEFAULT_RED_COLOR}
                onClickEvent={onClickModalExit}
              />
            </Grid>
          </Grid>
        </Grid>
      </BaseModal>
    );
}

BaseModalError.defaultProps = {
    maxWidth: 'md',
    close: false,
    buttonTitle: '',
};

BaseModalError.propTypes = {
    handleCloseModal: PropTypes.func.isRequired,
    maxWidth: PropTypes.string,
    buttonTitle: PropTypes.string,
    close: PropTypes.bool,
    messages: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default BaseModalError;
